var map = {
	"./AdminLayout": 6356,
	"./AdminLayout.vue": 6356,
	"./Dashboard": 3368,
	"./Dashboard.vue": 3368,
	"./Products/Advert": 683,
	"./Products/Advert.vue": 683,
	"./Products/Categories": 2375,
	"./Products/Categories.vue": 2375,
	"./Products/Index": 3594,
	"./Products/Index.vue": 3594,
	"./Services/Index": 9253,
	"./Services/Index.vue": 9253,
	"./Slider/Index": 4206,
	"./Slider/Index.vue": 4206,
	"./Teams/Index": 8953,
	"./Teams/Index.vue": 8953,
	"./Training/Create": 6743,
	"./Training/Create.vue": 6743,
	"./Training/Index": 7908,
	"./Training/Index.vue": 7908,
	"./WhyUs/Index": 1877,
	"./WhyUs/Index.vue": 1877,
	"./auth/Login": 4171,
	"./auth/Login.vue": 4171
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;